<template>
    <v-container fluid>
        <v-card color="#6499faff" dark class="rounded-xl">
            <v-card-title>
                <v-row align="center">
                    <v-col cols="12" lg="4">
                        {{ $t('menu.sports') }}
                    </v-col>
                    <!-- <v-col cols="12">
                        <sport-filters @setFilters="setFilters"/>
                    </v-col> -->
                    <v-col cols="12" align="end">
                        <v-btn class="my-2 mr-2" dark small color="black" @click="createSport">
                            <v-icon dark>mdi-plus</v-icon>{{ $t('button.create') }}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <array-view
            :items="sports"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @onDelete="onDelete"
        />
    </v-container>
</template>

<script>
    import sportService from '@/services/sport'
    import ArrayView from '@/components/ArrayView'
    // import SportFilters from '@/components/SportFilters'

    export default {
        name: 'Sport',
        components: { ArrayView },
        data: () => {
            return {
                sports: [],
                displayInfo: [
                    { text: 'table.id', value: 'id' },
                    { text: 'table.name', value: 'name' }
                ],
                size: 100,
                totalPages: 0,
                page: 1,
                loading: false,
                filters: null,
                message: null
            }
        },
        watch: {
            filters: {
                handler() {
                    this.fetchFilteredSports()
                }
            }
        },
        created() {
            this.filters = this.$store.getters.getSportFilters
            this.page = this.$store.getters.getPage
            this.fetchFilteredSports()
        },
        methods: {
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.$store.dispatch('setPage', page)
                this.fetchFilteredSports()
            },
            handleClick(action, item) {
                this.$router.push(`/sports/${item.id}/${action}`)
            },
            createSport() {
                this.$router.push(`/sports/create`)
            },
            onDelete(item, page) {
                sportService.deleteSport(item.id).then(() => {
                    this.page = page
                    this.fetchFilteredSports()
                })
            },
            setFilters(filters) {
                this.filters = filters
                this.$store.dispatch('setSportFilters', this.filters)
            },
            fetchFilteredSports() {
                this.loading = true
                sportService.getFilteredSports(this.filters, this.page, this.size).then(resp => {
                    this.sports = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.loading = false
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
